const api = {
  aws_appsync_graphqlEndpoint: process.env.REACT_APP_URL_GRAPH_QL,
  aws_appsync_region: 'eu-west-3',
  aws_appsync_authenticationType: 'API_KEY',
  aws_appsync_apiKey: process.env.REACT_APP_API_KEY,
};

export default api;
